module.exports = __webpack_public_path__ + "static/media/blog_beneficios_agricultura_canimolt.2a0789da.png";